// Settings: not built yet. Email settings live under Administration, and your own details under Profile Settings.
import React from "react";
import { ComingSoon } from "../components/ui";

const Settings = () => <ComingSoon title="Settings" description="Use Email Settings (Administration) and Profile Settings (Account) for now." />;

export default Settings;
